import React, { useContext } from 'react'
import styled from 'styled-components'
import PriceRowTaxesAndFees from 'components/Luxkit/PricePoints/PriceRowTaxesAndFees'
import GeoContext from 'contexts/geoContext'
import { pluralizeToString } from 'lib/string/pluralize'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'

const Root = styled.div`
`

interface Props {
  rate?: App.BedbankRate;
  offer: App.BedbankOffer | App.BedbankOfferSummary;
}

function HeroBedbankPriceDetails(props: Props) {
  const {
    rate,
    offer,
  } = props

  const { isTaxExclusiveRegion } = useContext(GeoContext)

  const taxesAndFees = rate?.totals?.taxesAndFees ?? 0
  const propertyFees = rate?.totals?.propertyFees ?? 0
  const hotelPrice = rate ? (isTaxExclusiveRegion ? rate.totals.exclusive : rate.totals.inclusive) : offer.sell?.price
  const hotelValue = rate?.value ?? offer.sell?.value
  const hotelDiscount = rate?.discount ?? offer.sell?.discount ?? 0

  const hotelNights = rate?.nights ?? offer?.sell?.los

  if (!hotelPrice) {
    return null
  }
  const totalPrice = isTaxExclusiveRegion ? hotelPrice : hotelPrice + propertyFees

  return <Root>
    <PriceRowPriceCaption>
      {pluralizeToString('night', hotelNights!)} from
    </PriceRowPriceCaption>
    <PriceRowPrice size="L" price={totalPrice} saleUnit="total" taxesAndFees={taxesAndFees} />
    <PriceRowTaxesAndFees taxesAndFees={taxesAndFees} />
    {hotelDiscount > 0 && <PriceRowValueDiscountWithCaption
      size="M"
      value={hotelValue || hotelPrice}
      discountPercentage={Math.floor(hotelDiscount * 100)}
    />}
  </Root>
}

export default HeroBedbankPriceDetails
